import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["innerHTML"]

import Markdown from "vue3-markdown-it";
import {inject} from "vue";


export default {
  __name: 'AppHelperItem',
  props: {
  item: {
    type: Object,
    default() {
      return {}
    }
  },
  itemKey: {
    type:  [String, Number],
    default: ''
  }
},
  setup(__props) {

/**
 * @doc Renderizza e gestisce una singola voce all'interno dell'Helper
 * @requires TheHelper.vue
 */
const props = __props

/**
 * @inject {updateHelperActived} recupera il metodo per aggiornare l'informazione dell'helper attiva
 */
const updateHelperActived = inject('updateHelperActived')

/**
 * @inject {helperActived} recupera il valore dell'informazione attiva dell'helper
 */
const helperActived = inject('helperActived')

/**
 * @inject {helperOver} recupera il valore dell'hover sull'helper
 */
const helperOver = inject('helperOver')

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.itemKey,
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_unref(updateHelperActived)(__props.itemKey === _unref(helperActived) ? '' : __props.itemKey, __props.itemKey)), ["prevent"])),
    class: "crm:cursor-pointer"
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(["crm:text-md crm:inline-block crm:font-medium", {'crm:zinc-900': __props.itemKey === (_unref(helperActived) || _unref(helperOver)), 'crm:text-zinc-400' : __props.itemKey !== _unref(helperActived)}])
    }, _toDisplayString(__props.item.label), 3 /* TEXT, CLASS */),
    (__props.item['compiler'] === undefined || __props.item['compiler'] !== 'md')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: __props.item.content,
          class: _normalizeClass(["crm:text-sm", {'crm:line-clamp-3': (_unref(helperActived) && __props.itemKey !== _unref(helperActived)) || !_unref(helperActived),
               'crm:text-zinc-400' : __props.itemKey !== _unref(helperActived)}])
        }, null, 10 /* CLASS, PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    (__props.item['compiler'] === 'md')
      ? (_openBlock(), _createBlock(_unref(Markdown), {
          key: 1,
          source: __props.item.content,
          class: _normalizeClass({'crm:line-clamp-3': (_unref(helperActived) && __props.itemKey !== _unref(helperActived)) || !_unref(helperActived)})
        }, null, 8 /* PROPS */, ["source", "class"]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}
}

}